import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import brandingStyles from '../branding/brandingStyles';
import metricsTools from '../utils/metricsTools';

import './MetricsSummary.css';

// MetricsSummary Component
class MetricsSummary extends Component {
    getTotalOps(operations) {
        let total = 0;
        for (const key in operations) {
            if (key) {
                total += operations[key];
            }
        }
        return total;
    }

    formatStorageDiff(value) {
        let res = '';
        if (value < 0) {
            res += '-';
        } else if (value > 0) {
            res += '+';
        }
        res += metricsTools.bytesToSize(Math.abs(value));
        return (res);
    }

    render() {
        const styles = {
            smallIcon: {
                fontSize: '18px',
            },
            lessMargin: {
                marginTop: '0px',
                marginBottom: '3px',
            },
        };

        const totalStorageTooltip = (
          <Tooltip id="tooltip">
            Total storage used
          </Tooltip>
        );

        const quotaTooltip = (
          <Tooltip id="tooltip">
            Storage quota
          </Tooltip>
        );

        return (
          <div className="panel panel-default"
            style={brandingStyles.backgrounds.panel}>
            <div className="panel-heading"
              style={brandingStyles.backgrounds.panelHeader}>
              <i
                className="fa fa-list"
                style={brandingStyles.mainColor}
              />
              <span>&nbsp;</span>
              Metrics Summary
            </div>
            <div className="panel-body metrics-summary">


              <div
                className="col-md-3 col-sm-6 p-t-15 p-b-15"
              >
                <ul className="in-col margin-t-10">
                  <li>
                    <OverlayTrigger
                      placement="top"
                      overlay={totalStorageTooltip}
                    >
                      <i
                        style={brandingStyles.mainColor}
                        className="fa fa-hdd-o fa-2x"
                      />
                    </OverlayTrigger>
                  </li>
                  <li>
                    <h3 className="no-margin no-padding font-light">
                      {
                          this.props.storage
                        && this.props.storage[1]
                        && metricsTools.bytesToSize(this.props.storage[1])
                        || 0
                      }
                    </h3>
                  </li>
                </ul>
                {
                  this.props.quota ?
                  (<ul className="in-col margin-t-10">
                    <li>
                      <OverlayTrigger
                        placement="top"
                        overlay={quotaTooltip}
                      >
                        <i
                          style={brandingStyles.mainColor}
                          className="fa fa-tasks fa-2x"
                        />
                      </OverlayTrigger>
                    </li>
                    <li>
                      <h3 className="no-margin no-padding font-light">
                        {metricsTools.bytesToSize(this.props.quota)}
                      </h3>
                    </li>
                  </ul>)
                  : null
                }
                <h4 className="card-label p-l-10 m-b-0">
                  Total storage
                  &nbsp;
                  <span
                    className="badge"
                    style={brandingStyles.buttons.primary}
                  >
                    {
                        this.props.storage
                      && this.props.storage[1]
                      && this.formatStorageDiff(
                        this.props.storage[1] - this.props.storage[0]
                      ) || 0
                    }
                  </span>
                </h4>
              </div>
              <div className="col-md-3 col-sm-6 p-t-15 p-b-15">
                <ul className="in-col margin-t-10">
                  <li>
                    <i
                      style={brandingStyles.mainColor}
                      className="fa fa-wrench fa-2x"
                    />
                  </li>
                  <li>
                    <h3 className="no-margin no-padding font-light">
                      {this.getTotalOps(this.props.operations)}
                    </h3>
                  </li>
                </ul>
                <h4 className="card-label p-l-10 m-b-0">
                  Total operations
                </h4>
              </div>


              <div className="col-md-3 col-sm-6 p-t-15 p-b-15">
                <ul className="in-col margin-t-10">
                  <li>
                    <i
                      style={brandingStyles.mainColor}
                      className="fa fa-files-o fa-2x"
                    />
                  </li>
                  <li>
                    <h3 className="no-margin no-padding font-light">
                      {this.props.objects && this.props.objects[1] || 0}
                    </h3>
                  </li>
                </ul>
                <h4 className="card-label p-l-10 m-b-0">
                  Total objects
                  &nbsp;
                  <span
                    className="badge"
                    style={brandingStyles.buttons.primary}
                  >
                    {(this.props.objects[1] - this.props.objects[0]) > 0 && '+'}
                    {this.props.objects
                      && (this.props.objects[1] - this.props.objects[0])
                      || 0}
                  </span>
                </h4>
              </div>

              <div
                className="col-md-3 col-sm-6 p-t-15 p-b-15"
              >
                <ul className="in-col">
                  <li style={{ display: 'block' }}>
                    <h4
                      style={Object.assign(
                        {},
                        styles.lessMargin,
                          {
                              paddingBottom: '3px',
                              borderBottom: '1px solid #565a5d',
                          }
                      )}
                      className="no-margin no-padding font-light"
                    >
                      <i
                        style={Object.assign(
                          styles.smallIcon,
                          brandingStyles.mainColor
                        )}
                        className="fa fa-arrow-circle-up fa-2x"
                      />
                      &nbsp;
                      <span style={brandingStyles.mainColor}>In</span>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      {metricsTools.bytesToSize(this.props.inThroughput)}
                    </h4>
                  </li>
                  <li style={{ display: 'block' }}>
                    <h4
                      style={styles.lessMargin}
                      className="no-margin no-padding font-light"
                    >
                      <i
                        style={Object.assign(styles.smallIcon,
                          brandingStyles.mainColor)}
                        className="fa fa-arrow-circle-down fa-2x"
                      />
                      &nbsp;
                      <span style={brandingStyles.mainColor}>Out</span>
                      &nbsp;&nbsp;
                      {metricsTools.bytesToSize(this.props.outThroughput)}
                    </h4>
                  </li>

                </ul>
                <h4 className="card-label p-l-10 m-b-0">
                  Bandwidth
                </h4>
              </div>

              <span className="clearfix"></span>


            </div>
          </div>
        );
    }
}

MetricsSummary.propTypes = {
    storage: PropTypes.array.isRequired,
    quota: PropTypes.number,
    objects: PropTypes.array.isRequired,
    inThroughput: PropTypes.number.isRequired,
    outThroughput: PropTypes.number.isRequired,
    operations: PropTypes.object.isRequired,
};

export default MetricsSummary;



/** WEBPACK FOOTER **
 ** ./src/components/MetricsSummary.js
 **/